import { render, staticRenderFns } from "./ValueOptionCard.vue?vue&type=template&id=31743b6f&"
import script from "./ValueOptionCard.vue?vue&type=script&lang=ts&"
export * from "./ValueOptionCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports